
import {
  Box,
  Stack
} from '@mui/material';
import { useNotificationPostedSubscription } from 'generated/graphql';


import {
  NotificationWidget,
  OrganizationNavbar
} from 'modules';
import React from 'react';
import {
  Outlet,
  useLocation
} from 'react-router-dom';



export type OrganizationLayoutProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const OrganizationLayout = (props: OrganizationLayoutProps) => {
  const location = useLocation();
  // subscription here because technically scoped outside of the user.
  useNotificationPostedSubscription();

  if (location.pathname.includes('plans/')) {
    return (
      <Box>
        <Outlet />
      </Box>
    );
  }

  return (
    <Stack
      direction='row'
      position='relative'
    >{
        __showNavBar(location.pathname) && (
          <OrganizationNavbar.FC />
        )
      }
      <Box
        flex='1 1 0'
      >
        <Outlet />
      </Box>
      <NotificationWidget.FC />
    </Stack >
  );
};

function __showNavBar(locationPath: string) {
  if (locationPath.endsWith('organization/projects')) {
    return false;
  }
  if (locationPath.includes('plans/')) {
    return false;
  }
  return true;
}


